import Vue from 'vue';
import Router from 'vue-router';
import Main from './views/main.vue';
import about from './views/About-us.vue'
//import contact from './views/contact.vue'
/*import TrinityToolkit from './views/trinity-toolkit.vue'
import Products from './views/products.vue'
import ProductsPdf from './views/products-pdf.vue'
import ProductsMeta from './views/products-meta.vue'
import ProductsLink from './views/products-link.vue'*/
import NotFound from './views/Not-found.vue'
import privacy from './views/privacy.vue'
import pricing from './views/pricing.vue'
import Solid from './views/solid.vue'
import features from './views/features.vue'
import pdfGraphing from './views/pdfGraphing.vue'
import solidLDP from './views/solid-ldp.vue'
/*import blog from './views/blog.vue'
import blogPage20190204 from './views/blog-page-20190204.vue'
import blogPage20190214 from './views/blog-page-20190214.vue'
import blogPage20190306 from './views/blog-page-20190306.vue'
import survey from './views/survey.vue'*/
import Construction from './views/construction.vue'
import ConstructionTrinApps from './views/construction-trinapps.vue'
import ConstructionTrinApp from './views/construction-trinapp.vue'
import ConstructionCDE from './views/construction-cde.vue'
import ConstructionCrosslink from './views/construction-crosslink.vue'
import ConstructionTrinPod from './views/construction-trinpod.vue'
import ConstructionTrinPodAconex from './views/construction-trinpod-aconex.vue'
import ConstructionPdf from './views/construction-pdf.vue'
import ConstructionMeta from './views/construction-meta.vue'
import ConstructionLink from './views/construction-link.vue'
import TrinApp from './views/trinapp.vue'
import TrinAppFiles from './views/trinapp-files.vue'
import TrinPod from './views/trinpod.vue'
import Property from './views/property.vue'
import Logistics from './views/logistics.vue'
import Terms from './views/terms.vue'
//import support from './views/support.vue'
//import partnerSupport from './views/partner-support.vue'
//import NewHome from './views/new-home.vue'
import Documents from './views/documents.vue'
import Launchpad from './views/launchpad.vue'
import Files from './views/files.vue'
import Projects from './views/projects.vue'
import Pods from './views/pods.vue'
import IntelligentPDF from './views/intelligent-pdf.vue'
import Building from './views/building.vue'
import Productivity from './views/productivity.vue'
import BuildingKnowledgeAccelerator from './views/building-knowledge-accelerator'
import TrinPodServer from './views/trinpod-server.vue'
import TrinAppSearch from './views/trinapp-search.vue'
import Aconex from './views/aconex.vue'
import AconexRegister from './views/aconex-register.vue'
import AconexFindFast from './views/aconex-find-fast.vue'
import AconexCde from './views/aconex-cde.vue'
import AconexHelp from './views/aconex-help.vue'
import Recovery from './views/recovery.vue'
import RecoveryWhyUs from './views/recovery-why-us.vue'
//import Developer from './views/developer.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
	{
	    path: '',
	    name: 'main',
	    component: Main
	},
	{
	    path: '/about',
	    name: 'about',
	    // route level code-splitting
	    // this generates a separate chunk (about.[hash].js) for this route
	    // which is lazy-loaded when the route is visited.
	    component: about
	},
	{
	    path: '/trinity-toolkit',
			redirect: '/trinapp',
	    /*name: 'TrinityToolkit',
	    component: TrinityToolkit*/
	},
	{
	    path: '/products',
			redirect:'/',
	    //name: 'Products',
	    //component: Products
	},
	{
	    path: '/construction',
			redirect: '/Aconex',
	    //name: 'Construction',
	    //component: Construction
	},
	{
	    path: '/construction/trinapps',
			redirect:'/trinapp',
	    //name: 'ConstructionTrinapps',
	    //component: ConstructionTrinApps
	},
	{
	    path: '/construction/trinapps/trinapp',
			redirect:'/',
	    //name: 'ConstructionTrinapp',
	    //component: ConstructionTrinApp
	},
	{
	    path: '/construction/trinapps/trinapp/cde',
			redirect:'/Aconex',
	    //name: 'ConstructionCDE',
	    //component: ConstructionCDE
	},
	{
	    path: '/construction/trinapps/trinapp/cde/crosslink',
			redirect:'/trinpod-server',
	    //name: 'ConstructionCrosslink',
	    //component: ConstructionCrosslink
	},
	{
	    path: '/construction/trinpod',
			redirect:'/trinpod-server',
	    //name: 'ConstructionTrinPod',
	    //component: ConstructionTrinPod
	},
	{
	    path: '/construction/trinpod/aconex',
			redirect:'/Aconex',
	    //name: 'ConstructionTrinPodAconex',
	    //component: ConstructionTrinPodAconex
	},
	{
	    path: '/construction/Trinity-PDF',
			redirect:'/trinapp',
	    //name: 'Trinity-PDF',
	    //component: ConstructionPdf
	},
	{
	    path: '/construction/Trinity-Meta',
			redirect:'/trinapp',
	    //name: 'Trinity-Meta',
	    //component: ConstructionMeta
	},
	{
	    path: '/construction/Trinity-Link',
			redirect: '/trinpod-server',
	    //name: 'Trinity-Link',
	    //component: ConstructionLink
	},
	/*{
	    path: '/web/pricing',
	    name: 'pricing',
	    component: pricing
	},
	{
	    path: '/web/solid',
	    name: 'solid',
	    component: solid
	},
	{
	    path: '/web/construction',
	    name: 'construction',
	    component: construction
	},
	{
	    path: '/web/contact',
	    name: 'contact',
	    component: contact
	},
	{
	    path: '/web/features',
	    name: 'features',
	    component: features
	},
	{
	    path: '/web/pdf',
	    name: 'pdfGraphing',
	    component: pdfGraphing
	},
	{
	    path: '/web/solid-ldp',
	    name: 'solidLDP',
	    component: solidLDP
	},
	{
	    path: '/web/blog',
	    name: 'blog',
	    component: blog
	},
	{
	    path: '/web/blog-page-20190204',
	    name: 'blogPage20190204',
	    component: blogPage20190204
	},
	{
	    path: '/web/blog-page-20190214',
	    name: 'blogPage20190214',
	    component: blogPage20190214
	},
	{
	    path: '/web/blog-page-20190306',
	    name: 'blogPage20190306',
	    component: blogPage20190306
	},
	{
	    path: '/web/survey',
	    name: 'survey',
	    component: survey
	},
	{
	    path: '/web/support',
	    name: 'support',
	    component: support
	},
	{
	    path: '/web/partner-support',
	    name: 'partnerSupport',
	    component: partnerSupport
	    }*/
    	{
	    path: '/privacy',
	    name: 'privacy',
	    component: privacy
	},
	{
	    path: '/trinapp',
	    name: 'trinapp',
	    component: TrinApp
	},
	/*{
	    path: '/trinapps',
	    name: 'trinapps',
	    component: TrinApps
	},*/
	{
	    path: '/trinapp/files',
	    name: 'trinapp-files',
	    component: TrinAppFiles
	},
	{
	    path: '/trinpod', redirect: '/trinpod-server'
	    //name: 'TrinPod',
	    //component: TrinPod
	},
	{
	    path: '/logistics',
			redirect: '/Aconex',
	    //name: 'logistics',
	    //component: Logistics
	},
	{
	    path: '/property',
			redirect: '/Aconex',
	    //name: 'property',
	    //component: Property
	},
	{
	    path: '/terms',
	    name: 'terms',
	    component: Terms
	},
	/*{
	    path: '/new-home',
	    name: 'NewHome',
	    component: NewHome
	},*/
	{
		path: '/documents',
		name: 'Documents',
		component: Documents
	},
	{
		path: '/launchpad',
		name: 'Launchpad',
		component: Launchpad
	},
	{
		path: '/files',
		name: 'Files',
		component: Files
	},
	{
		path: '/projects',
		name: 'Projects',
		component: Projects
	},
	{
		path: '/pods',
		name: 'Pods',
		component: Projects
	},
	{
		path: '/intelligent-pdf',
		name: 'IntelligentPDF',
		component: IntelligentPDF
	},
	{
		path: '/building',
		redirect: '/Aconex',
		//name: 'Building',
		//component: Building
	},
	{
		path: '/productivity',
		redirect: '/trinapp',
		//name: 'Productivity',
		//component: Productivity
	},
	{
		path: '/property',
		name: 'Property',
		component: Property
	},
	/*{
		path: '/developer',
		name: 'Developer',
		component: Developer
	},*/
	{
		path: '/solid',
		name: 'Solid',
		component: Solid
	},
	{
		path: '/building-knowledge-accelerator',
		name: 'BuildingKnowledgeAccelerator',
		component: BuildingKnowledgeAccelerator
	},
	{
		path: '/trinpod-server',
		name: 'TrinPodServer',
		component: TrinPodServer
	},
	{
		path: '/trinapp-search',
		name: 'TrinAppSearch',
		component: TrinAppSearch
	},
	{
		path: '/Aconex',
		name: 'Aconex',
		component: Aconex
	},
	{
		path: '/Aconex/register',
		name: 'AconexRegister',
		component: AconexRegister
	},
	{
		path: '/Aconex/find-information-fast',
		name: 'AconexFindFast',
		component: AconexFindFast
	},
	{
		path: '/Aconex/cde',
		redirect: '/Aconex',
		//name: 'AconexCde',
		//component: AconexCde
	},
	{
		path: '/Aconex/help',
		name: 'AconexHelp',
		component: AconexHelp
	},
	{
		path: '/recovery',
		name: 'Recovery',
		component: Recovery
	},
	{
		path: '/recovery/why-us',
		name: 'RecoveryWhyUs',
		component: RecoveryWhyUs
	},
	{
	    // NotFound must be last
	    path: '/*',
	    name: 'NotFound',
	    component: NotFound
	}
    ]
});
